export default {"src":"/_next/static/media/bycycle.d58ebb73.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};